import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useBreadcrumbsStore = defineStore('breadcrumbs', () => {
  const company = ref<
    | {
        id?: string;
        name: string;
      }
    | undefined
  >(undefined);
  const folder = ref<
    | {
        id?: string;
        name: string;
      }
    | undefined
  >(undefined);
  const contractsFolder = ref<
    | {
        name: string;
      }
    | undefined
  >(undefined);
  const period = ref<
    | {
        id?: string;
        name: string;
      }
    | undefined
  >(undefined);
  const subFolder = ref<
    | {
        name: string;
      }
    | undefined
  >(undefined);

  const drop = () => {
    company.value = undefined;
    folder.value = undefined;
    contractsFolder.value = undefined;
    period.value = undefined;
    subFolder.value = undefined;
  };

  const update = (data: {
    company?: {
      id?: string;
      name: string;
    };
    folder?: {
      id?: string;
      name: string;
    };
    contractsFolder?: {
      name: string;
    };
    period?: {
      id?: string;
      name: string;
    };
    subFolder?: {
      name: string;
    };
  }) => {
    drop();
    if (data.company) {
      company.value = data.company;
    }
    if (data.folder) {
      folder.value = data.folder;
    }
    if (data.contractsFolder) {
      contractsFolder.value = data.contractsFolder;
    }
    if (data.period) {
      period.value = data.period;
    }
    if (data.subFolder) {
      subFolder.value = data.subFolder;
    }
  };

  return {
    company,
    folder,
    contractsFolder,
    period,
    subFolder,
    drop,
    update,
  };
});
